export default{
    'GenerarPDF.VisualizadorPDF':'Visualizador PDF',
    'GenerarPDF.Acercar':'Acercar',
    'GenerarPDF.Alejar':'Alejar',
    'GenerarPDF.Descargar':'Descargar PDF'
}